<section *ngIf="withActionPanel" class="action-panel" [class.visible]="actionPanelVisible | async">
  <ng-container *ngComponentOutlet="sidebarComponent"></ng-container>
  <fa-icon class="toggle-icon fa-chevron-left"  [icon]="['fas', 'chevron-left']" aria-label="Toggle" (click)="toggleActionPanel()"></fa-icon>
  <fa-icon class="toggle-icon fa-chevron-right"  [icon]="['fas', 'chevron-right']" aria-label="Toggle" (click)="toggleActionPanel()"></fa-icon>
</section>

<div class="inner">
  <router-outlet></router-outlet>
</div>
